<template>
  <a-card :bordered="false">
    <a-form :label-col="{span:2}" :wrapper-col="{span:7}">
      <a-form-item label="垛标">
        <a-row>
          <a-col><a-input placeholder="请输入垛标" v-model:value="formData.virtual_sn" style="width:225px;margin-right:5px"></a-input></a-col>
          <a-col><a-button @click="rebuild" type="primary">重建垛标</a-button></a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="垛标数量" > 
        <a-input-number placeholder="请输入垛标数量" style="width:225px" v-model:value="formData.virtualNum" v-inputFilter:Int :min="1"></a-input-number>
      </a-form-item>
      <a-form-item label="大标" v-if="formData.virtualNum"> 
          <div v-for="v in formData.virtualNum" :key="v"><a-input v-model:value="formData.group_codes[v-1]"  style="width:225px"></a-input></div>
      </a-form-item>
      <a-form-item :wrapper-col="{offset:2}">
          <a-button @click="onSubmit" type="primary">确定</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import { ref } from '@vue/reactivity'
import {virtual_code_to_associated} from '@/api/antiFleeing'
import { iscode } from '../../../utils/app'
import { onMounted } from '@vue/runtime-core'
export default {
    setup(){
       const formData=ref({
           virtualNum:1,
           virtual_sn:'',
           group_codes:[]
       })   
       const rebuild=()=>{
         var sn='DB'+new Date().getTime()+Math.floor(Math.random() * (9999 - 1000) ) + 1000;
          formData.value.virtual_sn=sn
       }
       const onSubmit=async ()=>{
           console.log(formData.value)
        //    去除数组第一个
        // if(!formData.value.group_codes[0]&&formData.value.group_codes.length){
        //     formData.value.group_codes.splice(0,1)
        // }
            let result=await virtual_code_to_associated(formData.value).then(res=>res.data).catch(error=>error)
            if(iscode(result,true)){
                    formData.value={
                        virtualNum:1,
                        virtual_sn:'',
                        group_codes:[]
                    }
            }
       }
       onMounted(()=>{
         rebuild()
       })  
       return{
           formData,
           onSubmit,
           rebuild
       }
    }
}
</script>